import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { Helmet } from 'react-helmet';

import store, { loadPage } from '../../state';
import Blocks from '../../components/blocks';
import MaxWidth from '../../components/max-width';

import './page.css';

function getSlug(branch) {
  if (branch.route) {
    const match = /^\/([^/]*)/.exec(branch.route.path);
    if (match) {
      return match[1] ? match[1] : 'home';
    }
  }

  return null;
}

class Page extends Component {
  static fetchData(dispatch, branch) {
    return dispatch(loadPage(getSlug(branch)));
  }

  constructor(props) {
    super(props);
    const { node } = this.props;

    this.state = {
      slug: getSlug(this.props),
    };

    if (!node || (!node.get('isLoaded') && !node.get('isLoading'))) {
      store.dispatch(loadPage(this.state.slug));
    }
  }

  render() {
    const { node } = this.props;
    if (!node) return null;
    return (
      <div className={`page-type-page page-${this.state.slug}`}>
        <MaxWidth className="page-content">
          <div className="page-title">
            <h3>{node.get('title')}</h3>
          </div>
          <div className="intro" dangerouslySetInnerHTML={{ __html: node.get('intro') }} />
          <Blocks blocks={node.get('blocks')} />
        </MaxWidth>
        <Helmet>
          <html className={this.state.slug} lang="en" />
          <title>DCG Design | {node.get('title')}</title>
        </Helmet>
      </div>
    );
  }
}

Page.propTypes = {
  node: PropTypes.instanceOf(Map),
};

Page.defaultProps = {
  node: null,
};

const mapStateToProps = (state, ownProps) => {
  const slug = getSlug(ownProps);
  const node = state.getIn(['pages', slug]);

  return {
    node,
  };
};

export default connect(mapStateToProps)(Page);



// WEBPACK FOOTER //
// ./src/containers/page/index.jsx